import React, { useEffect, useState } from 'react';
import { Divider, Input, message, Modal } from 'antd';
import {
  CloseIcon,
  ContactImage,
  NewCloseIcon,
  NewHC200Icon,
  NewSaveIcon,
  UnassignedHS200DeviceIcon,
} from '../../Common/Icons';
import './LinkAccount.less';
import { PhotoResolution } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import {
  getProfilePicUrl,
  getUsername,
} from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { getProfilePics } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { useSelector } from 'react-redux';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const EditLinkedAccountModal = ({
  isEditLinkAccountModalOpen,
  isEditLinkAccountModalCancel,
  initialFormData = {},
  selectedStaff,
  hubRecord,
  onActionComplete,
}) => {
  const trans = useSelector(translator);
  const userApi = useSelector((state) => state.apis.userApi);
  const resourcesMap = useSelector(getProfilePics());
  const url = getProfilePicUrl(selectedStaff?.useruuid, resourcesMap, PhotoResolution.R64);
  const image =
    (selectedStaff?.profilePics && selectedStaff?.profilePics[PhotoResolution.R64]) ?? url;
  const [formData, setFormData] = useState({
    sourcerelationship: '',
    targetrelationship: '',
  });
  useEffect(() => {
    //populate state when modal form data is changed
    if (isEditLinkAccountModalOpen && initialFormData) {
      setFormData({
        sourcerelationship: initialFormData?.sourcerelationship ?? '',
        targetrelationship: initialFormData?.targetrelationship ?? '',
      });
    }
  }, [isEditLinkAccountModalOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isFormChanged = () => {
    return (
      formData.sourcerelationship.trim() !== (initialFormData?.sourcerelationship ?? '').trim() ||
      formData.targetrelationship.trim() !== (initialFormData?.targetrelationship ?? '').trim()
    );
  };

  const handleEditLinkAccountSubmit = () => {
    const trimmedFormData = {
      sourcerelationship: formData.sourcerelationship?.trim() || '',
      targetrelationship: formData.targetrelationship?.trim() || '',
    };
    const payload = {
      rolename: 'Social',
      firstname: selectedStaff?.firstname || '',
      lastname: selectedStaff?.lastname || '',
      email: selectedStaff?.email || '',
      sourcerelationship: trimmedFormData.sourcerelationship,
      targetrelationship: trimmedFormData.targetrelationship,
    };
    userApi.inviteContactsToUser(
      hubRecord?.useruuid,
      payload,
      apiCallback({
        successCallback: (res) => {
          // message.success("Contact relationship updated successfully!");
          onActionComplete?.(); // Close modal and optionally refresh list
        },
        errorCallback: (err) => {
          console.error('Edit linked contact failed', err);
          // message.error("Failed to update linked contact.");
        },
      })
    );
  };

  return (
    <Modal
      open={isEditLinkAccountModalOpen}
      onCancel={isEditLinkAccountModalCancel}
      footer={null}
      closable={false}
      centered
      className="edit-linked-contact-modal"
    >
      <div className="edit-linked-account-main-container">
        <div className="edit-linked-account-header-container">
          <span className="edit-linked-account-label">{trans('EDITLINKEDACCOUNT')}</span>
          <CloseIcon
            className="edit-linked-account-close-icon"
            onClick={isEditLinkAccountModalCancel}
          />
        </div>
        <div className="edit-linked-account-selected-account-container">
          <div className="edit-linked-account-social-contact">
            <span className="edit-linked-account-social-contact-label">
              {trans('SOCIALCONTACTTO')} {hubRecord?.firstname}
            </span>
          </div>
          <div className="edit-linked-account-selected-account-block">
            <div className="edit-linked-account-selected-account-card">
              <div className="edit-linked-account-selected-account-content">
                <div className="selected-assign-staff-profile">
                  {selectedStaff?.profilePics?.R64 || selectedStaff?.profilePic64 ? (
                    <img
                      src={selectedStaff?.profilePics?.R64 || selectedStaff?.profilePic64}
                      className="user-profile-pic user-profile-image"
                      alt="Selected Staff"
                    />
                  ) : (
                    <ContactImage className="photo-container" />
                  )}
                </div>
                <div className="selected-assign-staff-name-role-container">
                  <span className="selected-assign-staff-name-label">
                    {selectedStaff ? getUsername(selectedStaff) : ''}
                  </span>
                  <span className="selected-assign-staff-rolename-label">
                    {selectedStaff?.staffrole}
                  </span>
                </div>
              </div>
              <div className="edit-linked-account-device-container">
                {(selectedStaff?.useruuid === hubRecord?.useruuid &&
                  hubRecord?.deviceconnectstatus) ||
                selectedStaff?.deviceuuid != null ? (
                  <NewHC200Icon
                    status={
                      selectedStaff?.useruuid === hubRecord?.useruuid
                        ? hubRecord.deviceconnectstatus?.toLowerCase()
                        : selectedStaff.deviceconnectstatus?.toLowerCase()
                    }
                    className="device-assigned"
                  />
                ) : selectedStaff?.usertype === 'Principal' ? (
                  <UnassignedHS200DeviceIcon className="device-unassigned" />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <Divider className="edit-linked-account-divider" type="horizontal" />
        <div className="edit-linked-account-relationship-container">
          <div className="edit-linked-account-relationship-label-div">
            <div className="edit-linked-account-relationship-label">{trans('RELATIONSHIP')}</div>
          </div>
          <div className="edit-linked-account-relationship-card">
            <div className="edit-linked-account-relationship-row">
              <span className="edit-linked-account-relationship-header">
                {hubRecord?.firstname}
                {"'"}
                {trans('SRELATIONSHIPWITHTH')} {selectedStaff?.firstname}
              </span>
              <div className="edit-linked-account-relationship-input-box">
                <Input
                  className="edit-linked-account-relationship-input"
                  name="sourcerelationship"
                  value={formData.sourcerelationship}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="edit-linked-account-relationship-row">
              <span className="edit-linked-account-relationship-header">
                {selectedStaff?.firstname}
                {"'"}
                {trans('SRELATIONSHIPWITHTHIS')} {hubRecord?.firstname}
              </span>
              <div className="edit-linked-account-relationship-input-box">
                <Input
                  className="edit-linked-account-relationship-input"
                  name="targetrelationship"
                  value={formData.targetrelationship}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="edit-linked-account-footer">
          <div className="edit-linked-account-cancel-block" onClick={isEditLinkAccountModalCancel}>
            <div className="edit-linked-account-cancel-save">
              <NewCloseIcon className="edit-linked-account-cancel-icon" />
              <div className="edit-linked-account-cancel-save-label-block">
                <span className="edit-linked-account-cancel-label">{trans('CANCEL')}</span>
              </div>
            </div>
          </div>
          <div
            className={`edit-linked-account-save-block ${!isFormChanged() ? 'disabled' : ''}`}
            onClick={isFormChanged() ? handleEditLinkAccountSubmit : undefined}
          >
            <div className="edit-linked-account-cancel-save">
              <NewSaveIcon className="edit-linked-account-save-icon" />
              <div className="edit-linked-account-cancel-save-label-block">
                <span className="edit-linked-account-save-label">{trans('EDITCONTACT')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditLinkedAccountModal;
